import { StorageKey, ThemeSelection } from "@ctypes";
import { darkTheme, lightTheme } from "@layout";
import { useThemeStore } from "@stores";

const isSystemDarkTheme =
  window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches;

export const useTheme = () => {
  const {
    theme,
    setTheme: setThemeStore,
    selection,
    setSelection,
  } = useThemeStore((state) => state);

  const setTheme = (themeSelection: ThemeSelection) => {
    if (themeSelection === ThemeSelection.System) {
      setThemeStore(isSystemDarkTheme ? darkTheme : lightTheme);
    } else {
      setThemeStore(themeSelection === ThemeSelection.Dark ? darkTheme : lightTheme);
    }
    setSelection(themeSelection);
    localStorage.setItem(StorageKey.Theme, themeSelection);
  };

  const hydrate = async () => {
    const themeFromStorage = localStorage.getItem(StorageKey.Theme);

    if (themeFromStorage && themeFromStorage !== ThemeSelection.System) {
      setSelection(themeFromStorage as ThemeSelection);
      setThemeStore(themeFromStorage === ThemeSelection.Dark ? darkTheme : lightTheme);
    } else {
      setSelection(ThemeSelection.System);
      setThemeStore(isSystemDarkTheme ? darkTheme : lightTheme);
    }
  };

  return { theme, setTheme, hydrate, selection, setSelection };
};
